'use client';

import Image from 'next/image';
import { ActivatedPanel, SignedInFooter } from './activation-ui';

interface ActivationV2SuccessProps {
  firmName: string;
  userEmail: string;
}

/**
 * Temporary post-Stripe success screen for the v2 activation gate (LF-4535).
 *
 * Shown the moment the user returns from Stripe checkout, while the gate polls
 * the firm's `membershipStatus` for the backend webhook to flip it to `trial`
 * or `active`. Restores the confirmation the v1 gate gave: without it the v2
 * gate dropped the user straight onto the matters dashboard with no feedback
 * that activation had succeeded.
 */
export function ActivationV2Success({
  firmName,
  userEmail
}: ActivationV2SuccessProps) {
  return (
    <div className="bg-surface-subtle flex min-h-screen flex-col items-center justify-center px-6 py-12">
      <Image
        src="/ValeBlackLogo.svg"
        alt="Vale"
        width={40}
        height={40}
        priority
      />

      <div className="border-border bg-card mt-8 w-full max-w-lg rounded-xl border p-8 shadow-sm">
        <ActivatedPanel firmName={firmName} />
      </div>

      <SignedInFooter email={userEmail} className="mt-6" />
      <p className="text-muted-foreground mt-2 text-xs">
        &copy; Vale Innovations 2026
      </p>
    </div>
  );
}
